<template>
    <div class="modal-header">
        <div class="modal-title d-flex align-items-end" v-if="title || subtitle" :class="{'flex-row': titleLayout == 'horizontal', 'flex-column': titleLayout == 'vertical'}">
            <h5 class="modal-title" v-if="title"> {{ title }}</h5>
            <div class="modal-title" v-if="subtitle" :class="{'pl-1':title}" style="padding-bottom: 2px;"> {{ subtitle }} </div>
        </div>
        <button type="button" class="close" @click.prevent="close" aria-label="Close" v-if="enableClose"> <span aria-hidden="true">&times;</span> </button>
      <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'modal-header',
    props:{
        title: {
            type: String,
            default: null
        },
        titleLayout: {
            type: String,
            default: 'vertical'
        },
        subtitle: {
            type: String,
            default: null
        },
        enableClose:{
            type: Boolean,
            default: true
        }
    },
    methods:{
        close(){
            this.$parent.close();
        }
    }
}
</script>
